<script lang="ts" setup>
definePageMeta({ breadcrumb: 'Каталог' });
useHead({ title: 'Каталог – Hellride.ru' });

const catalogStore = useCatalogStore();

const [categories, brands] = await Promise.all([catalogStore.getCategories(), catalogStore.getBrands()]);
</script>

<template>
  <div class="catalog-page">
    <BreadcrumbsBlock />

    <div class="flex items-center gap-2">
      <BackButton />

      <h1>Каталог</h1>
    </div>

    <div
      v-if="categories.length"
      class="categories-grid"
    >
      <AppLink
        v-for="category in categories"
        :key="category.slug"
        :to="category.uri"
      >
        <CategoryListItem
          :category="category"
          class="transition duration-200 shadow-lg hover:shadow-md hover:translate-y-0.5"
        />
      </AppLink>

      <AppLink to="/sale">
        <CardBlock class="catalog-page__category-item">
          <SvgoSale
            :font-controlled="false"
            class="size-6 sm:size-12 text-hell-black"
            filled
          />

          <span class="text-sm"> Скидки </span>
        </CardBlock>
      </AppLink>

      <AppLink to="/new">
        <CardBlock class="catalog-page__category-item">
          <SvgoNew
            :font-controlled="false"
            class="size-6 sm:size-12 text-hell-black"
            filled
          />

          <span class="text-sm"> Новинки </span>
        </CardBlock>
      </AppLink>
    </div>

    <div v-else>Категории не найдены</div>

    <h2>Бренды</h2>

    <div
      v-if="brands.length"
      class="catalog-page__brand-items-grid"
    >
      <AppLink
        v-for="brand in brands"
        :key="brand.slug"
        :to="brand.uri"
      >
        <BrandLogoBlock
          :brand="brand"
          show-title
        />
      </AppLink>
    </div>

    <div v-else>Бренды не найдены</div>
  </div>
</template>

<style lang="scss" scoped>
.catalog-page {
  gap: 16px;

  @include inner-content;

  &__category-item {
    display: flex;
    gap: 16px;
    align-items: center;
    padding: 8px 12px;
    transition: all 0.2s;

    @include screen-sm {
      padding: 12px;
    }

    @apply shadow-lg hover:shadow-md hover:translate-y-0.5;
  }

  &__brand-items-grid {
    display: grid;
    grid-template-columns: repeat(4, auto);
    gap: 8px;
    justify-content: space-between;

    @include screen-xs {
      grid-template-columns: repeat(6, auto);
    }

    @include screen-md {
      grid-template-columns: repeat(7, auto);
      gap: 16px;
    }

    @include screen-lg {
      grid-template-columns: repeat(10, auto);
    }

    @include screen-xl {
      grid-template-columns: repeat(12, auto);
    }
  }
}
</style>
